// Configure React Router future flags
// This resolves the warnings about future behavior changes
export const routerConfig = {
  future: {
    v7_startTransition: true,
    v7_relativeSplatPath: true
  }
};

export default routerConfig;
